"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { trackEvent } from "@/lib/gtag";

interface ApplyButtonProps {
  href: string;
  className?: string;
  children: ReactNode;
}

// 自サイト内リンクはGA4のEnhanced Measurement（別ドメインのみ発火）の対象外のため、
// クリック時に同じ形のclickイベントを手動発火し、getBrokerClicks()と同じ
// linkUrl/pagePathディメンションで集計できるようにする。
export function ApplyButton({ href, className, children }: ApplyButtonProps) {
  const handleClick = () => {
    trackEvent("click", {
      link_url: new URL(href, window.location.origin).toString(),
      link_domain: window.location.hostname,
      link_text: typeof children === "string" ? children : "申し込む",
      outbound: false,
    });
  };

  return (
    <Link href={href} className={className} onClick={handleClick}>
      {children}
    </Link>
  );
}
